import { View, ViewProps } from "react-native";

export default function LoginBox({children}: ViewProps) {
    return (
        <div style={{
            minWidth: 860, minHeight: 460,
            borderRadius: 30,
            padding: 20,
            boxShadow: "0 2px 10px 0 rgba(79, 95, 216, 0.1)",
            backgroundColor: "#fff"
        }}>
            {children}
        </div>
    )
}